var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isPartOfForm
      ? _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("attach-file")))])])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: [_vm.isPartOfForm ? "w-100" : "col-lg-7 col-12 p-1"] },
      [
        _c("base-select", {
          attrs: {
            searchable: "",
            loading: _vm.tagSelect.loading,
            options: _vm.tagSelect.options,
            label: _vm.$i18nHelpers.normalizeProp("name"),
            valueProp: "id",
            placeholder: _vm.$t("select-file-type"),
            clearable: ""
          },
          model: {
            value: _vm.tagSelect.value,
            callback: function($$v) {
              _vm.$set(_vm.tagSelect, "value", $$v)
            },
            expression: "tagSelect.value"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.tagSelect.value
      ? _c(
          "div",
          [
            _vm.showDocumentOrLinkSelector
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.isPartOfForm
                        ? "d-flex justify-content-center"
                        : "col-lg-7 col-12 p-1"
                    ]
                  },
                  [
                    _c("base-radio-group", {
                      attrs: { options: _vm.documentOrLinkOptions },
                      model: {
                        value: _vm.documentOrLinkValue,
                        callback: function($$v) {
                          _vm.documentOrLinkValue = $$v
                        },
                        expression: "documentOrLinkValue"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showUploadBox
              ? _c("b-form-file", {
                  class: [
                    "mt-2",
                    _vm.isPartOfForm ? "w-100" : "col-lg-7 col-12"
                  ],
                  attrs: {
                    placeholder: _vm.$t("select-or-drag-drop-file"),
                    "drop-placeholder": _vm.$t("drag-drop-file"),
                    "browse-text": _vm.$t("browse")
                  },
                  on: { input: _vm.uploadFile },
                  model: {
                    value: _vm.file,
                    callback: function($$v) {
                      _vm.file = $$v
                    },
                    expression: "file"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showUploadLinkBox
              ? _c("div", { staticClass: "col-12 p-1 mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("base-input", {
                        staticClass: "col-12 col-md-5 pr-2 mb-2",
                        attrs: {
                          zeroMarginBottom: "",
                          placeholder: _vm.$t("name")
                        },
                        model: {
                          value: _vm.link.name,
                          callback: function($$v) {
                            _vm.$set(_vm.link, "name", $$v)
                          },
                          expression: "link.name"
                        }
                      }),
                      _vm._v(" "),
                      _c("base-input", {
                        staticClass: "col-12 col-md-5 px-2 mb-2",
                        attrs: {
                          zeroMarginBottom: "",
                          placeholder: "URL (http://...)"
                        },
                        model: {
                          value: _vm.link.url,
                          callback: function($$v) {
                            _vm.$set(_vm.link, "url", $$v)
                          },
                          expression: "link.url"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass: "w-100",
                              on: { click: _vm.uploadLink }
                            },
                            [
                              _vm.isPartOfForm
                                ? _c("b-icon-plus-lg")
                                : _c("span", [_vm._v(_vm._s(_vm.$t("save")))])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d64efd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d64efd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/UploadFileSelect.vue
// module id = 2645
// module chunks = 2 5 14 31 34 64 147